import { CreateTask } from '@ui/initiatives';
import { GearLinkSection } from './GearLinkSection';
import { getInitiativeRoute } from '@lib/routes';
import { OptionFilter } from '@periscopes/general/filters';
import { useInitiativeTasks } from '@hooks';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { memo, useCallback, useMemo, useState } from 'react';
export const TaskSelector = memo(({ initiativeId, onChange, value }) => {
    const { tasks, refresh } = useInitiativeTasks(initiativeId, true);
    const [open, setOpen] = useState();
    const options = useMemo(() => {
        var _a;
        return (_a = tasks.map((task) => ({
            label: task.name,
            value: task.initiativeTaskId
        }))) !== null && _a !== void 0 ? _a : [];
    }, [tasks]);
    const handleOnFinish = useCallback((taskId, taskName) => {
        setOpen(false);
        setTimeout(() => setOpen(undefined));
        refresh();
        onChange({
            label: taskName,
            value: taskId
        });
    }, [onChange, refresh]);
    return (React.createElement(GearLinkSection, { route: getInitiativeRoute(initiativeId) },
        React.createElement(OptionFilter, { filterOption: true, labelInValue: true, onChange: onChange, open: open, options: options, placeholder: COPY_GENERIC.SELECT(COPY_SPECIFIC.TASK), popupRender: (menu) => React.createElement(React.Fragment, null,
                menu,
                React.createElement(CreateTask, { initiativeId: initiativeId, onFinish: handleOnFinish })), value: value })));
});
